import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const schema = z.object({
  senderName: z.string().email().optional().or(z.literal('')),
});

export type DefaultSenderEmailFormContextType = z.infer<typeof schema>;

type DefaultSenderEmailFormProviderProps = {
  defaultValues: DefaultSenderEmailFormContextType;
  children: React.ReactNode;
};

export const DefaultSenderEmailFormProvider = ({
  children,
  defaultValues,
}: DefaultSenderEmailFormProviderProps) => {
  const methods = useForm<DefaultSenderEmailFormContextType>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
